const OfferPropertyModel = {
  label: { pl: '' },
  value: { pl: '' },
  position: 1,
  userMustBeLoggedIn: false,
  userMustInvest: false,
};

export default OfferPropertyModel;
